<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 32 33">
    <path
      d="M5.50389 9.11475C4.94979 9.11475 4.47998 9.58473 4.47998 10.1387V23.4507C4.47998 24.0046 4.94997 24.4746 5.50389 24.4746H26.4959C27.05 24.4746 27.5198 24.0046 27.5198 23.4507V10.1387C27.5198 9.58455 27.0498 9.11475 26.4959 9.11475H5.50389ZM7.02389 10.6508H24.9759L15.9999 18.3468L7.02389 10.6508ZM6.01584 11.7947L11.4156 16.4265L6.01584 21.8263V11.7947ZM25.9838 11.7947V21.8267L20.5841 16.427L25.9838 11.7947ZM12.5841 17.435L15.5041 19.9311C15.6428 20.0484 15.8185 20.1127 16.0002 20.1127C16.1818 20.1127 16.3575 20.0484 16.4963 19.9311L19.4163 17.435L24.9203 22.939H7.08025L12.5841 17.435Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
